export const INTERVIEW_PERMISSION_DENIED = 'interview_permission_denied';
export const INTERVIEW_START_BUTTON_CLICKED = 'interview_start_button_clicked';
export const INTERVIEW_NEXT_QUESTION_CLICKED =
  'interview_next_question_clicked';
export const INTERVIEW_END_INTERVIEW_CLICKED =
  'interview_end_interview_clicked';
export const SCREEN_RECORDING_NOT_AVAILABLE = 'screen_recording_not_available';
export const EVENT_SHORTLINK_LOAD_ERROR = 'shortlink_load_error';
